import { render } from "./LoadFile.vue?vue&type=template&id=3e0dddbc&scoped=true"
import script from "./LoadFile.vue?vue&type=script&lang=js"
export * from "./LoadFile.vue?vue&type=script&lang=js"

import "./LoadFile.vue?vue&type=style&index=0&id=3e0dddbc&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/topik-vue/topik-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e0dddbc"]])

export default __exports__